import { visuallyHidden } from "plos/src/styles/utils.css";
import { useTranslation } from "react-i18next";

/**
 * Screen-reader-only fixture label used in player sheets for fixture and history items and table cells.
 * @param name - Opponent team name.
 * @param isHome - Whether the fixture is at home.
 */
export const AccessibleFixtureText = ({
  name,
  isHome,
}: {
  name: string;
  isHome: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <span className={visuallyHidden}>{`${name}, ${
      isHome ? t("fixtures.home", "Home") : t("fixtures.away", "Away")
    }`}</span>
  );
};
